<template>
  <div class="row">
    <div class="service">
      <div class="text-center"><h5>Vui lòng nhập đầy đủ thông tin</h5></div>
      <div class="col-12">
        <div class="fr_form">
          <div
            v-if="inputs && inputs.length > 0"
            class="col-12 mt-2">
            <div class="fr_form">
              <form>
                <div
                  v-for="att in inputs"
                  class="form-group">
                  <label>{{ att.display }}</label>
                  <input
                    v-model="att.code"
                    type="hidden">
                  <input
                    v-if="att.type === 'text'"
                    :placeholder="att.display"
                    v-model="att.value"
                    type="text"
                    class="form-control">
                  <input
                    v-if="att.type === 'date' || att.type === 'month'"
                    :placeholder="att.display"
                    v-model="att.value"
                    type="date"
                    class="form-control">
                  <div v-if="att.sub_items && att.sub_items.length > 0">
                    <select
                      v-if="att.type === 'select'"
                      v-model="att.value"
                      class="form-control">
                      <option
                        v-for="option in att.sub_items"
                        :value="option.id">
                        {{ option.value }}
                      </option>
                    </select>
                  </div>
                  <vue-clock-picker
                    v-if="att.type === 'time'"
                    v-model="att.value"
                    class="form-control"
                    active-color="#4CAF50"
                    style="width: 100%!important;"
                    input-class="clock-picker__input"
                    done-text="Chọn"
                    cancel-text="Hủy"/>
                </div>

                <button
                  type="button"
                  class="btn btn-order btn-pri"
                  @click="orderLaso()">Mua lá số
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'
  import rf from  '../../communicate/RequestFactory';
  import {errorToaster} from '../../services/ErrorHandler'
  import OrderType from '../../communicate/OrderType'

  export default {
    name: 'LaSoOrder',
    data() {
      return {
        base_url: ApiConfig.base_url,
        inputs: [],
        phone: "",
        order: {
          product_code: 'PT-DV-22',
          attrs: [],
          target: -1
        },
      }
    },
    mounted () {
      const userInfoStorage = localStorage.getItem("current_user");
      if (userInfoStorage) {
        const userInfo = JSON.parse(userInfoStorage);
        this.phone = userInfo.phone;
      }
      this.getAttrLaso();
    },

    methods: {
      getAttrLaso() {
        rf.getRequest('ServiceRequest').getLasoAttrs().then((res) => {
          if (res.status === 200) {
            if (res.data && res.data.length > 0) {
              res.data.forEach(item => {
                this.inputs.push({
                  display: item.product_attribute_display,
                  code: item.product_attribute_code,
                  value: '',
                  type: item.product_attribute_input_type,
                  sub_items: item.product_attribute_input_value
                })
              })
            }

          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`});
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
        })
      },

      orderLaso() {
        if (this.inputs && this.inputs.length > 0) {
          this.inputs.forEach(item => {
            this.order.attrs.push({
              value: item.value,
              code: item.code
            })
          })
        }

        rf.getRequest("ServiceRequest").orderService(this.order).then((res) => {
          if (res.status === 200) {
            const req = {
              order_id: res.data.order_id,
              order_code: res.data.order_code,
              customer_number: this.phone,
              description: `Thanh toan don hang ${res.data.order_code}`,
              payment_method: res.data.payment_method,
              amount: parseInt(res.data.price),
              payment_type: OrderType.ORDER_DV
            };
            this.requestViettel(req);
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push("/login");
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối")
        })
      },

      requestViettel(req) {
        rf.getRequest("OrderRequest")
          .viettelPayCourse(req)
          .then(res => {
            if (res.status === 200) {
              window.location.href = res.data;
            }
            if (res.status === 401 || res.status === 403) {
              this.$router.push('login');
            } else {
              errorToaster('Xảy ra lỗi trong quá trình thanh toán')
            }
          })
          .catch(err => {
            errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
          });
      },

    }
  }
</script>

<style scoped>
  .btn-pri {
    background: #4189EB;
    color: #fff;
    border-radius: 45px;
  }
  .fr_form {
    background-color: #efefef;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/LaSoOrder.vue